import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCallsService } from './network/api-calls.service';
import { api } from 'src/app/utils/endpoints';
import { Buffer } from 'buffer';
import { InformedAlertService } from '../common/popups/informed-alert.service';
import { alertMessages } from 'src/app/utils/popup-messages';
import { AuthPermissionsService } from './auth-permissions.service';
import { ToastrService } from 'ngx-toastr';
import * as CryptoJS from 'crypto-js';
import { _clone } from 'src/app/utils/constants';
import { CommonDataSharingService } from './common-data-sharing.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  navigationData: any;
  private readonly _secretKey: string = 'overfoods-admin-encrytion';

  constructor(private _router: Router, private _apiCalls: ApiCallsService, private _alerts: InformedAlertService,
    private _authPermissions: AuthPermissionsService, private _toastr: ToastrService, private _commonDataService: CommonDataSharingService) { }

  login(request: any) {
    return new Promise((resolve, reject) => {
      const login = _clone(request);
      delete request.rememberMe;
      this._apiCalls.postDataWithoutLoader(api._adminLogin, request).subscribe({
        next: (res: any) => {
          // this._commonDataService.getRegionsList();
          if (login.rememberMe)
            this.saveUserCredentials(login);
          else
            this._clearSessionDetails();
          this._navigateToDashboard(res.data.accessToken);
        },
        error: (error: any) => reject()
      });
    });
  }

  signOut(): void {
    this._apiCalls.put(api._logoOut, {}).subscribe({
      next: (res: any) => {
        this._authPermissions.clearPermissions();
        this._clearLocalStorage();
      },
      error: (error: any) => console.log(error)
    });
  }

  forgotPassword(request: any) {
    return new Promise((resolve, reject) => {
      this._apiCalls.postDataWithoutLoader(api._forgotPassword, request).subscribe({
        next: (res: any) => {
          this._toastr.success('OTP sent to entered email address.');
          this._navigateToVerifyOtp(res.data.accessToken);
          resolve(res);
        },
        error: (error: any) => reject()
      });
    });
  }

  verifyTokenForResetPassword(token: any): void {
    this._apiCalls.put(api._verifyTokenForResetPassword, { token: token }).subscribe({
      next: (res: any) => {
      },
      error: (error: any) => console.log(error)
    });
  }

  verifyOtpForResetPassword(request: any) {
    return new Promise((resolve, reject) => {
      this._apiCalls.put(api._verifyOtp, request).subscribe({
        next: (res: any) => {
          this._toastr.success('OTP verified successfully, Please set new password.');
          this._navigateToResetPassword(res.data.accessToken);
        },
        error: (error: any) => {
          console.log(error);
          reject();
        }
      });
    });
  }

  resendOtpForResetPassword(token: any) {
    return new Promise((resolve, reject) => {
      this._apiCalls.post(api._resendForgotPasswordOTP, { token: token }).subscribe({
        next: (res: any) => {
          this._toastr.success('OTP sent to entered email address.');
          resolve(res);
        },
        error: (error: any) => console.log(error)
      });
    });
  }

  resetForgotPassword(request: any) {
    return new Promise((resolve, reject) => {
      this._apiCalls.put(api._resetForgotPassword, request).subscribe({
        next: (res: any) => {
          this._toastr.success('Password changed successfully.');
          this._clearLocalStorage();
        },
        error: (error: any) => reject()
      })
    });
  }

  tokenProfile(token: any) {
    return new Promise((resolve, reject) => {
      this._apiCalls.get(api._tokenProfile, { token: token }).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (error: any) => reject()
      })
    });
  }

  setupAccount(request: any) {
    return new Promise((resolve, reject) => {
      this._apiCalls.post(api._setupAccount, request).subscribe({
        next: (res: any) => {
          this._toastr.success('Account has been successfully created.');
          this._navigateToDashboard(res.data.accessToken);
        },
        error: (error: any) => reject()
      })
    });
  }

  profileUpdate(request: any) {
    return new Promise((resolve, reject) => {
      // this._apiCalls.put(api._addAdmin, request)
      //   .subscribe((res) => {
      //     const adminProfile = this.getUserProfile();
      //     adminProfile.firstName = request.firstName;
      //     adminProfile.lastName = request.lastName;
      //     if (request.image != '' && request.image)
      //       adminProfile.image = request.image;
      //     if (request.phoneNumber)
      //       adminProfile.phoneNumber = request.phoneNumber;
      //     this._updateUserProfile(adminProfile);
      //     resolve(adminProfile);
      //   });
    });
  }

  changePassword(request: any) {
    return new Promise((resolve, reject) => {
      this._apiCalls.put(api._changePassword, request).subscribe({
        next: (res: any) => {
          resolve(res);
          this._clearLocalStorage();
          // this._alerts.showSuccessAlert(alertMessages.passwordChangedSuccessfully)
          //   .then((result: any) => {
          //     if (result.value) {
          //       this._clearLocalStorage();
          //     }
          //   })
        }
      });
    });
  }

  getUserProfile() {
    return this._apiCalls.get(api._currentProfile);
    // const adminDetail = localStorage.getItem('adminDetail');
    // if (adminDetail)
    //   return JSON.parse(atob(adminDetail || ''));
  }

  private _navigateToDashboard(token: any) {
    this._saveAuthToken(token);
    this._router.navigate(['/dashboard']);
  }

  private _navigateToVerifyOtp(token: any) {
    this._router.navigate(['/auth/verify-otp/' + token]);
  }

  private _navigateToResetPassword(token: any) {
    this._router.navigate(['/auth/reset-password/' + token]);
  }

  private _updateUserProfile(adminDetail: any): void {
    const string = JSON.stringify(adminDetail)
    localStorage.setItem('adminDetail', Buffer.from(string).toString('base64'))
  }

  private _saveAuthToken(token: any): void {
    localStorage.setItem('adminToken', Buffer.from(token).toString('base64'))
  }

  private _saveUserDetails(res: any): void {
    const adminDetails = JSON.stringify(res.data.adminDetails)
    localStorage.setItem('adminDetail', Buffer.from(adminDetails).toString('base64'))
  }

  private _clearLocalStorage(): void {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminDetail');
    this._router.navigate(['/auth/login']);
  }

  private _clearSessionDetails(): void {
    localStorage.removeItem('sessionDetails');
  }

  authenticatedUserRouting(): boolean {
    const token = localStorage.getItem('adminToken');
    if (token)
      return true;
    this._clearLocalStorage();
    return false;
  }

  anonymousRouting(): boolean {
    const token = localStorage.getItem('adminToken');
    if (!token)
      return true;
    this._router.navigate(['/dashboard']);
    return false;
  }

  saveUserCredentials(loginDetails: any): void {
    const encryptedDetails = CryptoJS.AES.encrypt(JSON.stringify(loginDetails), this._secretKey).toString();
    localStorage.setItem('sessionDetails', encryptedDetails);
  }

  get isAuthenticated(): boolean {
    const token = localStorage.getItem('adminToken');
    if (token)
      return true;
    return false;
  }

  get credentials(): any {
    const credentials = localStorage.getItem('sessionDetails');
    if (credentials) {
      const decryptedBytes = CryptoJS.AES.decrypt(credentials, this._secretKey);
      const decryptedMessage = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
      return decryptedMessage;
    }
    return null;
  }
  public setNavigateData(data:any) {
    this.navigationData = data;
  }
  public getNavigateData() {
    if(this.navigationData)
      return this.navigationData;
    else
      return null;
  }

}
